import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const RegistrationForm = (props) => (
  <Svg
    width={69}
    height={70}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M58.389 6.404 19.775.293c-1.347-.213-2.608.727-2.817 2.1L8.573 57.452c-.21 1.373.713 2.66 2.06 2.872l38.613 6.11c1.347.213 2.609-.728 2.818-2.1l8.385-55.059c.209-1.373-.713-2.658-2.06-2.872Z"
        fill="#D1D9E9"
      />
      <Path
        d="M49.74 7.963H10.664c-1.363 0-2.468 1.126-2.468 2.516v55.717c0 1.39 1.105 2.516 2.468 2.516H49.74c1.363 0 2.468-1.127 2.468-2.516V10.48c0-1.39-1.105-2.516-2.468-2.516Z"
        fill="#ECEFF5"
      />
      <Path
        d="M47.55 58.695c0 3.05-2.424 5.52-5.415 5.52-2.992 0-5.416-2.47-5.416-5.52 0-3.049 2.424-5.52 5.416-5.52 2.991 0 5.415 2.471 5.415 5.52Z"
        fill="#F65E5E"
      />
      <Path
        d="M13.677 18.87c0-1.17 0-1.755.238-2.198a2 2 0 0 1 .817-.817c.443-.238 1.028-.238 2.199-.238h26.028c1.17 0 1.756 0 2.2.238a2 2 0 0 1 .816.817c.238.443.238 1.028.238 2.199 0 1.17 0 1.756-.238 2.199a2 2 0 0 1-.817.817c-.443.237-1.028.237-2.199.237H16.931c-1.171 0-1.757 0-2.2-.237a2 2 0 0 1-.816-.817c-.238-.443-.238-1.029-.238-2.2ZM13.677 30.584c0-1.171 0-1.756.238-2.2a2 2 0 0 1 .817-.816c.443-.238 1.028-.238 2.199-.238h26.028c1.17 0 1.756 0 2.2.238a2 2 0 0 1 .816.817c.238.443.238 1.028.238 2.199 0 1.17 0 1.756-.238 2.198a2 2 0 0 1-.817.818c-.443.237-1.028.237-2.199.237H16.931c-1.171 0-1.757 0-2.2-.237a2 2 0 0 1-.816-.818c-.238-.442-.238-1.028-.238-2.198ZM13.677 42.297c0-1.171 0-1.756.238-2.2a2 2 0 0 1 .817-.816c.443-.238 1.028-.238 2.199-.238h14.315c1.171 0 1.756 0 2.2.238a2 2 0 0 1 .816.817c.238.443.238 1.028.238 2.199 0 1.17 0 1.756-.238 2.198a2 2 0 0 1-.817.818c-.443.237-1.028.237-2.199.237H16.931c-1.171 0-1.757 0-2.2-.237a2 2 0 0 1-.816-.818c-.238-.442-.238-1.028-.238-2.198Z"
        fill="#fff"
      />
    </G>
    <Path
      d="M48.306 69.248c-5.75 0-10.59-.27-14.36-.6-2.323-.204-3.778-2.61-2.887-4.766 2.471-5.98 5.522-11.887 9.101-17.617a122.97 122.97 0 0 1 6.777-9.773 3.459 3.459 0 0 1 5.487 0 122.95 122.95 0 0 1 6.742 9.717c3.56 5.693 6.6 11.564 9.067 17.507.896 2.158-.565 4.567-2.892 4.771a195.09 195.09 0 0 1-17.035.76Z"
      fill="#F1C796"
    />
    <Path
      d="M50.493 35.235c-.675.177-1.306.6-1.774 1.268a124.998 124.998 0 0 0-6.216 9.86 125.247 125.247 0 0 0-8.348 17.774c-.741 1.97.286 4.148 2.071 4.692-.798-.057-1.558-.119-2.279-.182-2.324-.204-3.778-2.609-2.888-4.765 2.471-5.98 5.522-11.887 9.101-17.617 2.437-3.9 4.788-7.187 6.777-9.773a3.454 3.454 0 0 1 3.556-1.257Z"
      fill="#DEBC94"
    />
    <Path
      d="M48.676 44.354a9.687 9.687 0 0 1 1.942 0 1.652 1.652 0 0 1 1.475 1.589c.099 2.69.099 5.379 0 8.069a1.652 1.652 0 0 1-1.475 1.588 9.672 9.672 0 0 1-1.942 0 1.652 1.652 0 0 1-1.475-1.588c-.099-2.69-.099-5.38 0-8.07a1.652 1.652 0 0 1 1.475-1.588ZM48.724 58.552c.615-.03 1.231-.03 1.847 0 .849.04 1.53.724 1.568 1.572.038.828.038 1.655 0 2.483a1.651 1.651 0 0 1-1.568 1.572c-.616.03-1.232.03-1.847 0a1.651 1.651 0 0 1-1.569-1.572 27.475 27.475 0 0 1 0-2.483 1.651 1.651 0 0 1 1.569-1.572Z"
      fill="#fff"
    />
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(.5)" d="M0 0h67.674v68.976H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default RegistrationForm
